/* eslint-disable @typescript-eslint/no-explicit-any */
// tslint:disable:no-require-imports
export default async function localePolyfill(force?: any) {
  if (!(window as any).Intl || !Intl.PluralRules || force) {
    try {
      if (!(window as any).Intl) {
        // Really old browsers
        // @ts-expect-error: legacy intl package lacks type declarations
        await import('intl');
        await Promise.all([
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ar-AE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ar-IL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ar-MA'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/bg-BG'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/da-DK'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/de-AT'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/de-CH'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/de-DE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/de-LU'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-AU'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-CA'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-BM'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-GB'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-GG'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-GY'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-IE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-IL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-KY'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-US'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/en-NZ'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-AR'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-CL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-CO'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-CR'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-DO'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-EC'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-ES'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-GT'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-HN'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-MX'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-PA'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-PE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/es-SV'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/fi-FI'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/fr-BE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/fr-CA'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/fr-CH'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/fr-FR'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/he-IL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/hr-HR'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/hu-HU'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/it-CH'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/it-IT'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ja-JP'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ka-GE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ko-KR'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/lv-LV'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ms-MY'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/nb-NO'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/nl-BE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/nl-NL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/pl-PL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/pt-BR'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/pt-PT'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ro-RO'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/ru-RU'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/sl-SI'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/sq-AL'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/sv-SE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/sw-KE'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/th-TH'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/vi-VN'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/zh-Hans-HK'),
          // @ts-expect-error: legacy intl package lacks type declarations
          import('intl/locale-data/jsonp/zh-Hans-SG'),
        ]);
      }

      if (!Intl.PluralRules || force) {
        // @ts-expect-error: legacy intl package lacks type declarations
        await import('intl-pluralrules');
      }
      (window as any).IntlPolyfillLoaded = true;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}
